export const goToHome = (navigate) => {
  navigate("/")
}
export const goToNewPassword = (navigate) => {
  navigate("/newpassword")
}
export const goToLogin = (navigate) => {
  navigate("/login")
}
export const goToUsers = (navigate) => {
  navigate("/users")
}
export const goToDoctor = (navigate) => {
  navigate("/doctors")
}
export const goToTypes = (navigate) => {
  navigate("/types")
}
export const goToPatients = (navigate) => {
  navigate("/patients")
}
export const goToProviders = (navigate) => {
  navigate("/providers")
}
export const goToIncomes = (navigate) => {
  navigate("/inflows")
}
export const goToExpense = (navigate) => {
  navigate("/outflows")
}
export const goToNewUser = (navigate) => {
  navigate("/users/create")
}
export const goToNewDoctor = (navigate) => {
  navigate("/doctors/create")
}
export const goToNewType = (navigate) => {
  navigate("/types/create")
}
export const goToNewPatients = (navigate) => {
  navigate("/patients/create")
}
export const goToNewProvider = (navigate) => {
  navigate("/providers/create")
}
export const goToNewIncome = (navigate) => {
  navigate("/inflows/create")
}
export const goToNewExpense = (navigate) => {
  navigate("/outflows/create")
}
export const goEditUser = (navigate, id) => {
  navigate(`/users/create?id=${id}`)
}
export const goEditDoctor = (navigate, id) => {
  navigate(`/doctors/create?id=${id}`)
}
export const goEditType = (navigate, id) => {
  navigate(`/types/create?id=${id}`)
}
export const goEditPatients = (navigate, id) => {
  navigate(`/patients/create?id=${id}`)
}
export const goEditProviders = (navigate, id) => {
  navigate(`/providers/create?id=${id}`)
}
export const goEditInflow = (navigate, id, patient_id, patient_name) => {
  navigate(`/inflows/create?id=${id}&patient_id=${patient_id}&patient_name=${patient_name}`)
}
export const goEditOutflow = (navigate, id, provider_id, provider_name) => {
  navigate(`/outflows/create?id=${id}&provider_id=${provider_id}&provider_name=${provider_name}`)
}
export const goDeleteUser = (navigate, id) => {
  navigate(`/users/${id}`)
}
export const goDeleteInflow = (navigate, id) => {
  navigate(`/inflows/${id}`)
}
export const goDeleteOutflows = (navigate, id) => {
  navigate(`/outflows/${id}`)
}
